function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8119 10.3431L16.5637 14.5913L12.3156 10.3431C11.9282 9.95575 11.2943 9.95575 10.9069 10.3431C10.5195 10.7305 10.5195 11.3645 10.9069 11.7519L15.155 16L10.9069 20.2481C10.5195 20.6355 10.5195 21.2695 10.9069 21.6569C11.1006 21.8506 11.3559 21.9474 11.6112 21.9474C11.8665 21.9474 12.1219 21.8506 12.3156 21.6569L16.5637 17.4087L20.8119 21.6569C21.0056 21.8506 21.2609 21.9474 21.5162 21.9474C21.7715 21.9474 22.0269 21.8506 22.2206 21.6569C22.608 21.2695 22.608 20.6355 22.2206 20.2481L17.9724 16L22.2206 11.7519C22.608 11.3645 22.608 10.7305 22.2206 10.3431C21.8332 9.95575 21.1992 9.95575 20.8119 10.3431Z",
  fill: "black"
});

var SvgBgRemove = function SvgBgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 32C25.0866 32 32.25 24.8366 32.25 16C32.25 7.16344 25.0866 0 16.25 0C7.41344 0 0.25 7.16344 0.25 16C0.25 24.8366 7.41344 32 16.25 32Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-remove.77a407df.svg";
export { ForwardRef as ReactComponent };